// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface XMyListDetailsTagsModelStateType {
    isOpen: boolean;
}

export const initialTagsModelState: XMyListDetailsTagsModelStateType = {
    isOpen: false,
};

const reducer = {
    "xMyListDetails/TagsModel/SetTagsModelIsOpen": (
        draft: Draft<XMyListDetailsTagsModelStateType>,
        action: { isOpen: boolean },
    ) => {
        draft.isOpen = action.isOpen;
    },
};

const xMyListDetailsTagsModel = createTypedReducerWithImmer(initialTagsModelState, reducer);

(reducers as any).xMyListDetailsTagsModel = xMyListDetailsTagsModel;
export type xMyListDetailsTagsModelState = {
    xMyListDetailsTagsModel: XMyListDetailsTagsModelStateType;
} & ApplicationState;

type xMyListDetailsTagsModelReducers = {
    [key: string]: typeof xMyListDetailsTagsModel;
};

export type xMyListDetailsTagsModelActions =
    | Parameters<xMyListDetailsTagsModelReducers[keyof xMyListDetailsTagsModelReducers]>[1]
    | AnyAction;
